module.exports = __webpack_public_path__ + "img/vote-icon.1cb11fa0.svg";